// core
import React, { useEffect, useState } from "react";
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";
import Button from "../../../../common/components/Forms/Button/Button";
import Icon from "../../../../common/components/Icon/Icon";
import { IContactDetails } from "../../../../common/interfaces/IContactDetails";
import useDataLayer from "../../../hooks/useDataLayer";
import styles from "./ContactDetailsModal.module.scss";
import SecurityAndPrivacyModal from "../SecurityAndPrivacyModal/SecurityAndPrivacyModal";
import LegalAndDisclaimerModal from "../LegalAndDisclaimerModal/LegalAndDisclaimerModal";
import ContactDetailsForm from "../../ContactDetailsForm/ContactDetailsForm";
import cx from "classnames";
import Checkbox from "../../../../common/components/Forms/Checkbox/Checkbox";
import { getProductTypeAsString } from "../../../../common/shared/enumHelpers";

interface IContactDetailsModal {
    isOpen: boolean;
    contactDetails: IContactDetails;
    onSubmit: (contactDetails: IContactDetails) => Promise<boolean>;
}

const ContactDetailsModal: React.FC<IContactDetailsModal> = (props) => {
    const { isOpen, onSubmit } = props;

    const [isOpenSecurityAndPrivacyModal, setIsOpenSecurityAndPrivacyModal] = useState(
        false
    );
    const [isOpenLegalAndDisclaimerModal, setIsOpenLegalAndDisclaimerModal] = useState(
        false
    );

    // LDS-5659 Disclaimer checkbox removed; hasAcceptedDisclaimer will always be false for now (as at 12 April 2023)
    const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(false);

    const { sendEvent } = useDataLayer();

    useEffect(() => {
        if (isOpen) {
            sendEvent("contactDetailsModal");
        }
    }, [isOpen]);

    useEffect(() => {
        abTesting.convertAll(8, "", getProductTypeAsString, 0);
    }, []);

    return (
        <React.Fragment>
            <LModal
                Header={() => <ModalHeader title="Benefit by signing in" />}
                width="narrow"
                calcHeightMode="auto"
                isOpen={isOpen}
                backgroundDimStyle="blur">
                {() => (
                    <React.Fragment>
                        <SecurityAndPrivacyModal
                            isOpen={isOpenSecurityAndPrivacyModal}
                            onClose={() => {
                                setIsOpenSecurityAndPrivacyModal(false);
                            }}
                        />
                        <LegalAndDisclaimerModal
                            isOpen={isOpenLegalAndDisclaimerModal}
                            onClose={() => {
                                setIsOpenLegalAndDisclaimerModal(false);
                            }}
                        />
                        <ul
                            className={cx(
                                styles["selling-points"],
                                "text-semi-bold",
                                "text-font-size-ms",
                                "gap-l"
                            )}>
                            <li>Easily return to quotes later</li>
                            <li>Securely store quotes &amp; applications</li>
                            <li>Quotes are waiting for you!</li>
                        </ul>

                       

                        <ContactDetailsForm
                            onSubmit={onSubmit}
                            className="gap-2xl">
                            <div className="gap-2xl centered">
                                <span className="text-font-size-s">By continuing, you understand that these results aren't personalised to you and do not constitute personalised advice.</span>
                                <a href="/our-service/important-information.aspx" target="_blank" className="text-font-size-s space-auto"> More info</a>
                            </div>
                            </ContactDetailsForm>



                        {/* <ContactDetailsForm
                            onSubmit={onSubmit}
                            className="gap-xl"
                            isDisabled={!hasAcceptedDisclaimer}>
                            <Checkbox
                                name="disclaimer-acceptance"
                                size="l"
                                className="gap-xl"
                                checked={hasAcceptedDisclaimer}
                                onChange={(e) =>
                                    setHasAcceptedDisclaimer(e.target.checked)
                                }
                                label={
                                    <span className={cx("label-l space-pre-m")}>
                                        I understand that these results aren't
                                        personalised to me.{" "}
                                        <a
                                            href="/our-service/important-information.aspx"
                                            target="_blank">
                                            More info
                                        </a>
                                    </span>
                                }
                            />
                        </ContactDetailsForm> */}

                        <Button
                            component="button"
                            //isDisabled={!hasAcceptedDisclaimer}
                            onClick={() => {
                                window.location.assign(
                                    `/account/signin.aspx?returnUrl=${encodeURIComponent(
                                        window.location.pathname
                                    )}&isDisclaimerAccepted=${hasAcceptedDisclaimer}`
                                );
                            }}
                            className={cx("gap-l", "btn-secondary", "btn-full-width", "btn-trademe")}
                            dataAttributes={{
                                "data-ga_action": "signin-method",
                                "data-ga_category": "quote-form",
                                "data-ga_label": "trademe"
                            }}>
                            <Icon
                                id="TrademeKev"
                                className={cx(styles["trademe-icon"], "space-m")}
                            />
                            Or, sign in with Trade Me
                        </Button>

                        <div className={"layout-flex-row--justified-centered"}>
                            <a
                                className="text-font-size-s"
                                onClick={() => setIsOpenSecurityAndPrivacyModal(true)}>
                                Security &amp; privacy
                            </a>
                            <span>&nbsp;and&nbsp;</span>
                            <a
                                className="text-font-size-s"
                                onClick={() => setIsOpenLegalAndDisclaimerModal(true)}>
                                Legal &amp; disclaimer
                            </a>
                        </div>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default ContactDetailsModal;
